import React from 'react';
import { DateTime } from 'luxon';

const STATE_THRESHOOLD_IN_MINS = 3;

export const IssueTime = ({
    issueTime,
    targetTimezone,
    style,
    colour,
    isDarkMode = false,
}: {
    issueTime: string;
    targetTimezone?: string;
    style?: React.CSSProperties;
    colour?: string;
    isDarkMode?: boolean;
}) => {
    const issued = DateTime.fromISO(issueTime).setZone(targetTimezone);
    const { seconds } = issued.diffNow('seconds');
    const diffSec = Math.floor(Math.abs(seconds));
    const diffMin = Math.floor(diffSec / 60);

    const defaultColour = colour || style?.color || '#595959';
    const errorColor = isDarkMode ? '#E79598' : '#D83D3D';

    const isExpired = diffMin >= STATE_THRESHOOLD_IN_MINS;

    return (
        <div
            style={{
                fontSize: '12px',
                fontWeight: 400,
                ...style,
                color: isExpired ? errorColor : defaultColour,
            }}
        >
            {!isNaN(diffMin) && !isNaN(diffSec) && (
                <div style={{ height: 'fit-content' }}>{`${
                    isExpired
                        ? `(${diffMin} minutes ago) ${issued.toFormat('HH:mma ccc yy LLL')}`
                        : diffMin >= 1
                          ? `${diffMin} minute${diffMin > 1 ? 's' : ''} ago`
                          : diffSec >= 30
                            ? '30 sec ago'
                            : 'Just now'
                }`}</div>
            )}
        </div>
    );
};
